import { buildMaybePartnerRoute } from '../../helpers/builders.js';
import { DevRouteName } from './model.js';

const advancedSettingsRoute = (locationData) => buildMaybePartnerRoute({ ...locationData, name: DevRouteName.DEV_ADVANCED_SETTINGS });

export { advancedSettingsRoute };
